import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import Controller, { OnChange, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { ButtonAPI, FieldAPI, FormAPI, PanelAPI } from '@philips-internal/oswald-ui-components';
import { SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Validator } from '@philips-internal/oswald-ui-core/lib/services/model-service';
import { SCHEDULE_OTHER_STATUS } from '../../constants/schedule-status';
import { ContextType } from '@philips-internal/oswald-ui-core';

interface Context {
  data: {
    ieScheduleType: string;
    ieStatus: string;
    nrSeqAgenda: string;
    patientId: string;
  };
}

@Controller({ component: 'layout-appointment-cancel', fragment: 'appointment-cancel' })
export default class AppointmentCancelController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @Inject('form-cancel-appointment')
    formCancelAppointment!: FormAPI;

  @Inject('panel-loader')
    panelLoader!: PanelAPI;

  @Inject('panel-content-dropdown-cancel-appointment')
    panelContent!: PanelAPI;

  @Inject('field-reason-cancellation')
    fieldReasonCancellation!: FieldAPI;

  @Inject('field-dropdown-cancel-appointment')
    fieldDropdownCancelAppointment!: FieldAPI;

  @Inject('button-action-dropdown-cancel-appointment')
    buttonSubmit!: ButtonAPI;

  @OnMount({target: 'form-cancel-appointment'})
  onMountForm(): void {
    const isAppointmentRequest = this.context.get('ieScheduleType') === SCHEDULE_OTHER_STATUS.REQUESTED;

    this.fieldReasonCancellation.setVisible(isAppointmentRequest);
    this.fieldDropdownCancelAppointment.setVisible(!isAppointmentRequest);

    const requiredValidator: Validator = { name:'required', options:{} };

    if (isAppointmentRequest) {
      this.fieldReasonCancellation.addValidator(requiredValidator);
    } else {
      this.fieldDropdownCancelAppointment.addValidator(requiredValidator);
    }
  }

  @OnChange({target: 'form-cancel-appointment'})
  async onChangeForm(): Promise<void> {
    const isShowButton = await this.fieldReasonCancellation.validate() && await this.fieldDropdownCancelAppointment.validate();

    if (this.buttonSubmit.isEnabled() !== isShowButton) {
      this.buttonSubmit.setEnabled(isShowButton);
    }
  }

  @OnClick({ target: ['button-action-dropdown-cancel-appointment'] })
  async onConfirmCancelClick(): Promise<void> {
    interface MotivoCancelamentoAgenda {
      motivo: MotivoAgendaDropdown;
      reasonCancellation: string;
    }
    interface MotivoAgendaDropdown {
      cdMotivo: string;
      dsMotivo: string;
    }
    if (await this.fieldReasonCancellation.validate() && await this.fieldDropdownCancelAppointment.validate()) {
      const { data } = this.context as unknown as Context;
      const { nrSeqAgenda, ieScheduleType, patientId, ieStatus } = data;
      const { motivo, reasonCancellation } = this.formCancelAppointment.getRecord() as unknown as MotivoCancelamentoAgenda;
      const body = { ...motivo, reasonCancellation };
      this.panelContent.setVisible(false);
      this.panelLoader.setVisible(true);
      HttpService.post(APPLICATION_ENDPOINTS.CANCEL_AGENDA, {
        ieScheduleType,
        ieStatus,
        nrSeqAgenda,
        patientId,
      }, { body }).finally(() => {
        this.submittableFragmentContext.submit(new SubmitEvent());
      });
    }
  }
}
